<template>
  <div class="main-frame" id="main">
      <div class="main">
        <template v-for="section in sections" >
          <template v-if="section.type === 'PROFILE'">
            <div class="block">
              <div class="section-title" :id="section.id"><span v-html="section.label"/></div>
              <span v-html="section.text"/>
              <div v-if="section.contact" class="contact">
                <span v-html="section.contact.text"/>
                <span v-for="(v,index) in section.contact.values" :key="index">
                  <a v-html="v.picto" v-if="v.url" @click="open(v.url)"/>
                  <a v-html="v.picto" v-else-if="v.mail" :href="'mailto:' + v.mail"/>
                </span>
              </div>
            </div>
          </template>
          <template v-else-if="section.type === 'EXPERIENCE'">
            <div class="block">
              <div class="section-title" :id="section.id"><span v-html="section.label"/></div>
            </div>
            <transition-group name="list-complete" tag="div" class="blocks-container">
              <div class="block exp list-complete-item" v-for="(m, index) in getMissions(section)" :key="index" :id="'m'+(index+1)">
                <div class="logo"><img :src="asset(m.logo)"/><span class="title" v-html="m.title"/></div>
                <div class="date">{{ m.from}} <template v-if="m.to"> - {{ m.to }}</template></div>
                <div class="desc">
                  <p>
                    <span v-html="m.text"/>
                    <ul v-if="m.tasks && m.tasks.length > 0">
                      <li v-for="(t, index) in m.tasks"><span v-html="t"/></li>
                    </ul>
                  </p>
                </div>
                <div class="badges" v-if="m.badges && m.badges.length > 0"><div class="badge" v-for="(b, index) in m.badges">{{ b }}</div></div>
              </div>
            </transition-group>
            <div class="block show-more"><span @click="showMore" v-html="seeMoreLabel"/></div>
          </template>
          <template v-else-if="section.type === 'SKILLS'">
            <div class="block">
              <div class="section-title" :id="section.id"><span v-html="section.label"/></div>
              <p v-html="section.text"/>
              <div class="skills-container">
                <div class="skills" v-for="(s, index) in section.back" :key="index"><img :src="asset(s)"/></div>
              </div>
              <div class="skills-container">
                <div class="skills" v-for="(s, index) in section.front" :key="index"><img :src="asset(s)"/></div>
              </div>
              <div class="skills-container">
                <div class="skills" v-for="(s, index) in section.langs" :key="index"><img :src="asset(s)"/></div>
              </div>
            </div>
          </template>
          <template v-else-if="section.type === 'EDUCATIONS'">
            <div class="block">
              <div class="section-title" :id="section.id"><span v-html="section.label"/></div>
            </div>
            <div class="block edu" v-for="(e,index) in section.educations" :key="index">
              <div class="logo"><img :src="asset(e.logo)"/><span class="title" v-html="e.title"/></div>
              <div><span class="date">{{ e.year}}</span><span>{{ e.text }}</span></div>
            </div>
          </template>
        </template>

        <div class="block links" v-if="links && links.length > 0">
          <template v-for="(l, index) in links">
            <span class="link" :key="index" v-html="l.picto" @click="open(l.url)" v-if="l.url"/>
            <a class="link" :key="index" v-html="l.picto" @click="open(l.url)" v-else-if="l.mail" :href="'mailto:' + l.mail"/>
          </template>
        </div>

      </div>
    </div>
</template>

<script>
import assets from '@/libs/assets.js'
import zenscroll from 'zenscroll'

const maxMissions = 4

export default {
  name: 'body',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      seeAll: false
    }
  },
  methods: {
    open (url) {
      if (url && url.length > 0) {
        window.open(url)
      }
    },
    asset (key) {
      return assets[key]
    },
    getMissions (section) {
      if (!this.seeAll && this.hasMoreMissions(section)) {
        return section.missions.slice(0, maxMissions)
      }
      return section.missions
    },
    hasMoreMissions (section) {
      return section && section.missions && section.missions.length > maxMissions
    },
    showMore () {
      this.seeAll = !this.seeAll
      if (!this.seeAll) {
        var target = document.getElementById('m' + maxMissions)
        zenscroll.to(target, 500)
      }
    }
  },
  computed: {
    sections () {
      return this.content.sections
    },
    links () {
      return this.content.links
    },
    seeMoreLabel () {
      return this.seeAll ? '<i class="fa fa-minus-circle" aria-hidden="true"></i> Voir moins' : '<i class="fa fa-plus-circle" aria-hidden="true"></i> Voir plus'
    }
  }
}
</script>

<style scoped>

p {
  line-height: 1.5rem;
}

.main-frame {
  position: relative;
  background-color: #f3f3f3;
  z-index: 0;
}

.main {
  display: flex;
  flex-flow: row wrap;
  /* align-items: stretch; */
  max-width: 1024px;
  margin: auto;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
}

.block {
  margin: 3rem 2rem;
  margin-bottom: 0;
  box-sizing: border-box;
  flex-basis: calc(100% - 4rem);
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
}

.block.exp {
  flex-basis: calc(50% - 4rem);
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.block.edu {
  margin-top: 1rem;
}

.block.show-more {
  margin-top: 1.5rem;
  margin-bottom: 0;
  text-align: center;
  display: inline;
}

.show-more span {
  background: transparent;
  padding: .5rem 1rem;
  border: 2px solid #444;
  border-radius: 5px;
  color: #444;
  cursor: pointer;
  opacity: 0.25;
  transition: opacity .25s linear, color .25s linear;
  text-align: center;
}

.show-more span:hover {
  opacity: 1;
  color: #fd4900;
}

.section-title {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.section-title::before {
  content: "";
  border-top: 0.3rem solid #fd4900; /* #ff6a00; */
  width: 4rem;
  height: 2px;
  position: absolute;
  transform: translateY(2.5rem);
}

.title {
  vertical-align: middle;
}

.date {
  color: #555;
  /* font-size: 0.9rem; */
  line-height: 2rem;
  font-weight: bold;
  text-shadow: 1px 1px rgba(0,0,0,0.15);
  padding-right: 1.2rem;
}

.desc {
  /* flex: none; */
}

.logo {
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1rem;
}

.logo img {
  height: 2rem !important;
  margin-right: 1.5rem;
  vertical-align: middle;
}

.link {
  color: black;
  cursor: pointer;
  transition: color 0.25s linear;
  padding: 0 0.5rem;
}

.link:hover {
  color: #fd4900;
}

.skills-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.skills {
  margin: 0 1.5rem;
}

.skills img {
  width: 5rem;
  padding: 1rem 0.5rem;
}

.badges {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  align-content: flex-end;
  flex: auto;
}

.badge {
  font-size: 0.8rem;
  color: white;
  margin: 0.25rem 0.25rem;
  padding: 0.25rem 0.5rem;
  background: #bbb;
  border-radius: 4px;
}

.block.links {
  letter-spacing: 0.5rem;
  flex-flow: row wrap;
  justify-content: center;
}

.contact {
  align-self: flex-end;
  font-weight: bold;
  padding-top: 1rem;
}

.contact a {
  padding-left: 0.5rem;
  transition: color .25s linear;
  cursor: pointer;
  font-size: 1.5rem;
  vertical-align: middle;
}

.contact a:hover {
  color: #fd4900 !important;
}

.blocks-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

@media screen and (max-width: 750px) {
  .block.exp {
    flex-basis: calc(100% - 4rem);
  }
}

.list-complete-item {
  transition: transform .5s, opacity .5s;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(2rem);
}

</style>



// WEBPACK FOOTER //
// Body.vue?16398e60